// extracted by mini-css-extract-plugin
export default {"container":"feed_container__QzowO","scrollbar":"feed_scrollbar__LxNu6","srollbar":"feed_srollbar__2ZnAf"};